<div class="template-list-container">
  <form [formGroup]="searchForm">
    <div class="header">
      <div class="title-section">
        <h1>Workspace Templates</h1>
        <p>Manage your workspace templates efficiently.</p>
      </div>

      <div class="controls-section">
        <input formControlName="field" type="text" class="search-field" placeholder="Search templates..." />
        <a routerLink="create" mat-flat-button class="new-template-button">
          <mat-icon>add</mat-icon>
          Create New Template</a
        >
      </div>
    </div>

    <div class="filter-container">
      <div class="sort-section">
        <mat-form-field class="sort-select">
          <mat-label>Sort</mat-label>
          <mat-select formControlName="select">
            <mat-option [value]="null">None</mat-option>
            @for (sortValue of sortValues; track sortValue.id) {
              <mat-option [value]="sortValue.id">{{ sortValue.text }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <div class="view-controls">
        @if (isLoading$ | async) {
          <mat-spinner diameter="40"></mat-spinner>
        }
        <button mat-icon-button class="view-change" type="button" (click)="isListView = !isListView">
          @if (isListView) {
            <mat-icon>view_module</mat-icon>
          } @else {
            <mat-icon>list</mat-icon>
          }
        </button>
      </div>
    </div>
  </form>

  <div class="template-content" [class.list-view]="isListView">
    @if (pagedTemplates$ | async; as templates) {
      @if (templates.length) {
        @if (isListView) {
          <!-- List View -->
          <div class="list-layout">
            @for (template of templates; track template.id) {
              <app-template-list-element [isLink]="true" [template]="template"></app-template-list-element>
            }
          </div>
        } @else {
          <!-- Grid View -->
          <div class="grid-layout">
            @for (template of templates; track template.id) {
              <app-template-card [isLink]="true" [template]="template"></app-template-card>
            }
          </div>
        }
      } @else {
        <div class="no-data">
          <p>No templates found.</p>
        </div>
      }
    }
  </div>

  @if (totalTemplatesLength$ | async) {
    <mat-paginator
      (page)="handlePageEvent($event)"
      [length]="totalTemplatesLength$ | async"
      [pageSize]="paginatorTrigger$.value.pageSize"
      [pageIndex]="paginatorTrigger$.value.pageIndex"
      [pageSizeOptions]="pageSizeOptions">
    </mat-paginator>
  }
</div>
